import React, { FC } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

interface ServicosModelo {
  ServicoImagem: string;
  ServicoTitulo: string;
  ServicoDescricao: string;
}

const dadosTexto = {
  Titulo: 'Nossos Serviços',
  Texto: 'Confiança é a base do nosso compromisso com o associado. Nosso propósito é oferecer tranquilidade para quem usa seu veículo, para lazer ou trabalho. Seja carro, moto ou caminhão, nós temos a melhor proteção para garantir sua satisfação quando precisar usar algum benefício.'
};

const servicesData: ServicosModelo[] = [
  {
    ServicoImagem: '/images/servm3-3.jpg',
    ServicoTitulo: 'Assistência 24h',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    ServicoImagem: '/images/servm3-1.jpg',
    ServicoTitulo: 'Clube de Vantagens',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
  {
    ServicoImagem: '/images/servm2-med.jpg',
    ServicoTitulo: 'Telemedicina',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
  },
];

const Servicos: FC = () => {
  return (
    <section id="servicos" className="text-center bg-theme-gray p-6 gap-8 lg:px-14 py-12">
      <h2 className="text-textotitulo font-bold mb-4">{definicoescliente?.Servico?.Titulo || dadosTexto.Titulo}</h2>
      <p className="text-theme-dark text-textopadrao mb-8 max-w-xl mx-auto">
        {definicoescliente?.Servico?.Descricao || dadosTexto.Texto}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 p-4 gap-12">
        {(definicoescliente.Servico.Servicos.length ? definicoescliente.Servico.Servicos : servicesData)
          .map((service, index) => (
          <div key={index} className="flex flex-col bg-theme-white p-6 rounded-lg shadow-md items-center">
            <img src={service.ServicoImagem || servicesData[index]?.ServicoImagem} alt={service.ServicoTitulo || servicesData[index]?.ServicoTitulo} className="rounded-lg mb-4 max-h-[300px]"/>
            <h3 className="text-textotitulo font-semibold">{service.ServicoTitulo || servicesData[index]?.ServicoTitulo} </h3>
            <p className="text-theme-dark text-textopadrao">{service.ServicoDescricao || servicesData[index]?.ServicoDescricao} </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Servicos;
